function reviewStartButtonLabel(startedOn, saving) {
  if (saving) return '…';
  if (startedOn) return 'started';
  return 'Start';
}

module.exports = {
  reviewStartButtonLabel,
};
